import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/salesamplelist',
    selectPage(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelistFw/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistFw/selectById?id=' + v);
    },
    updateById(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelistFw/updateById',
            method: 'post',
            data: query
        });
    },
    toDelete(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistFw/toDelete?id=' + v);
    },
    Listed(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistFw/Listed?id=' + v);
    },
    below(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistFw/below?id=' + v);
    },
    showprocategory(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/showprocategory?id='+ v);
    },
    saveS(query){
        return http({
            url: this.baseurl + '/bscSalesSamplelistFw/insert',
            method: 'post',
            params: query
        });
    },
    selectUpdate(v){
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistLog/selectUpdate?id='+ v);
    }
}
